const FIELDS = {
  name: "name",
  room_id: "room_id",
}

export const validate = (field: string, value: string) => {
  let is_valid = false;
  if(field === FIELDS.name){
    if(!value){
      return false;
    }
    is_valid = (/^[0-9a-zA-Z]+$/.test(value) && value.length <= 10);
  }
  if(field === FIELDS.room_id){
    is_valid = /^[0-9a-f]+$/.test(value);
  }
  return is_valid;
}
